import TabsView from './tabs-view'

export default TabsView
